import { extendTheme } from '@chakra-ui/react';
import { tabsTheme } from './Tabs.theme';
import { menuTheme } from './Menu.theme';
import { checkboxTheme } from './Checkbox.theme';
import { pbThemeColors } from '../color';

const config = {
    initialColorMode: 'dark',
    useSystemColorMode: false,
};

export const chakraTheme = extendTheme({
    config,
    colors: {
        white50: 'rgba(255, 255, 255, 0.5)',
        mustardLight: 'rgb(198, 176, 50)', // #c6b032
        ...pbThemeColors,
    },
    fonts: {
        body: "'Roboto', 'Helvetica Neue', Arial, Helvetica, sans-serif",
        heading: "'Roboto', 'Helvetica Neue', Arial, Helvetica, sans-serif",
        mono: "'Roboto Mono', 'Lucida Console', Monaco, monospace",
    },
    components: {
        Tabs: tabsTheme,
        Menu: menuTheme,
        Checkbox: checkboxTheme,
    },
});
